import { render, staticRenderFns } from "./thanks-all.vue?vue&type=template&id=5ce97a14"
import script from "./thanks-all.vue?vue&type=script&lang=js"
export * from "./thanks-all.vue?vue&type=script&lang=js"
import style0 from "./thanks-all.vue?vue&type=style&index=0&id=5ce97a14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports